/* File has been copied */

import { RootState } from "../../app/rootReducer";
import { dialogSliceName } from "./dataTypes";

const selectSliceState = (state: RootState) => state[dialogSliceName];

export const selectMessage = (state: RootState) => selectSliceState(state).message;
